import { createTheme } from '@mui/material/styles';

const Colors = {
  primary: '#4AB428',
  secondary: '#FFC300'
}

export default createTheme({
  palette: {
    primary: {
      main: Colors.primary,
    },
    secondary: {
      main: Colors.secondary,
    },
    darkText: {
      main: '#000000',
    }
  },
  typography: {
    tab: {
      fontFamily: 'Raleway',
      textTransform: 'none',
      fontWeight: 700,
      color: 'white',
      fontSize: '1rem',
    },
    h1: {
      color: '#333',
    },
    h2: {
      color: '#333',
    },
    h3: {
      color: '#333',
    },
    h4: {
      color: '#333',
    },
  },
  overrides: {
    MuiLink: {
      root: {
        color: '#fff',
      },
    },
    MuiInputLabel: {
      root: {
        fontWeight: 400,
        fontSize: '1rem',
      },
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: `2px solid ${Colors.primary}`,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: `2px solid ${Colors.primary}`,
        },
      },
    },
    backgroundTheme: {
      backgroundColor: '#F0F2F5',
    },
  },
  breakpoints: {
    values: {
      zero: 0,
      xs: 320,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});
